const video = (selector) => {

    const progress = document.querySelectorAll(selector);
  
    progress.forEach( item => {
        item.addEventListener('input', function() {
            const value = this.value;
            console.log(value);
            this.style.background = `linear-gradient(to right, #710707 ${+value}%, #C4C4C4 ${+value + 1}%)`;
          });
    });

};

export default video;